var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-editor"},[_c('BaseStatusForm',{ref:"form",attrs:{"usedColors":_vm.usedColors}}),_vm._t("default",null,{"onCreate":_vm.onCreate,"onUpdate":_vm.onUpdate,"onRemove":_vm.onRemove})],2)}
var staticRenderFns = []

export { render, staticRenderFns }